module.exports = __webpack_public_path__ + "img/user-regular.29def3e5.svg";